<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-4xl text-theme-1 font-medium leading-none">Contact info</h2>
    </div>
    <!-- BEGIN: Profile Info -->
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5"
      >
        <div
          class="flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0"
        >
          <h5 class="text-lg font-medium leading-none mt-3">Email</h5>
          <h5 class="text-lg font-medium leading-none mt-3">Phone</h5>
          <h5 class="text-lg font-medium leading-none mt-3">Telegram</h5>
          <h5 class="text-lg font-medium leading-none mt-3">LinkedIn</h5>
        </div>
        <div
          class="flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center text-gray-600 dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0"
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            {{ settings[0].email }}
          </div>
          <div class="truncate sm:whitespace-normal flex items-center mt-3">
            {{ settings[0].phone }}
          </div>
          <div class="truncate sm:whitespace-normal flex items-center mt-3">
            {{ settings[0].telegram }}
          </div>
          <div class="truncate sm:whitespace-normal flex items-center mt-3">
            linkedin.com/in/pmst-converter-b6b178201
          </div>
        </div>
      </div>
    </div>
    <br />

    <div class="col-span-12 lg:col-span-8 xxl:col-span-9">
      <!-- BEGIN: Announcement -->
      <div class="intro-y box mt-5">
        <div
          class="flex items-center px-5 py-3 border-b border-gray-200 dark:border-dark-5"
        >
          <h2 class="text-4xl text-theme-1 font-medium leading-none">
            PMSTConverter
          </h2>
        </div>
        <div class="px-5">
          <div class="font-medium text-lg" />
          <br>The PMSTConverter team has a background in undertaking environmental assessments throughout Australia. The development of our tool
          and this secure platform came from our desire to reduce the amount of time wasted transcribing and compiling information needed to inform
          these assessments.<br>

          <br>We believe that our no fuss and secure platform provides the most efficient and reliable way to transcribe the Protected Matters Search Tool
          (PMST) results into an editable excel file. By providing a summary of the SPRAT profile distribution and habitat preferences for
          the majority of the EPBC listed fauna and flora with the output file it saves even more time.<br>

          <br> The PMST results are provided by the Australian Government and the <em>Environment Protection and Biodiversity Conservation Act 1999</em>
          (the EPBC Act) is the central piece of environmental legislation. The EPBC Act provides the legal framework to protect and manage nationally and internationally
          important flora, fauna, ecological communities and heritage places — defined as matters of national environmental significance.
          The EPBC Act is currently administered by the Department of Agriculture, Water and the Environment.<br>

          <br> To complete a search for matters of national environmental significance in your study area follow this link:
          <a class="text-theme-1 dark:text-theme-10" href="https://environment.gov.au/epbc/protected-matters-search-tool">Protected Matters Search Tool </a><br>

          <br> The PMSTConverter team regularly checks for any updates so that we can provide you with the most up to date information. This coupled
          with our sites <a class="text-theme-1 dark:text-theme-10" href="https://en.wikipedia.org/wiki/HTTPS">HTTPS encryption</a> and use of the
          <a class="text-theme-1 dark:text-theme-10" href="https://stripe.com/au">STRIPE</a>
          payment platform should give you supreme confidence every time you use our service.<br>

          <br>For more information please get in touch with the team through the platforms listed above.<br>

          <br> Follow the link to see our <a class="text-theme-1 dark:text-theme-10" href="/terms"
          >Terms and Conditions</a>.<br>


          <div class="text-gray-700 dark:text-gray-600 mt-2" />
          <div class="flex items-center mt-5" />
        </div>
      </div>
    </div>
    <br />


    <!--    <div class="intro-y col-span-12 lg:col-span-6">-->
    <!--      <h2 class="text-lg font-medium mr-auto">Contact form</h2>-->
    <!--      &lt;!&ndash; BEGIN: Form Layout &ndash;&gt;-->
    <!--      <div class="intro-y box p-5">-->
    <!--        <div>-->
    <!--          <input-->
    <!--            type="text"-->
    <!--            class="input w-full border mt-2"-->
    <!--            placeholder="Name"-->
    <!--          />-->
    <!--        </div>-->
    <!--        <div>-->
    <!--          <input-->
    <!--            type="text"-->
    <!--            class="input w-full border mt-2"-->
    <!--            placeholder="Email"-->
    <!--          />-->
    <!--        </div>-->
    <!--        <div class="mt-3">-->
    <!--          <label>Description</label>-->
    <!--          <div class="mt-2">-->
    <!--            <CKEditor-->
    <!--              :v-model="editorData"-->
    <!--              :editor="classicEditor"-->
    <!--              :config="simpleEditorConfig"-->
    <!--            />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="text-right mt-5">-->
    <!--          <button type="button" class="button w-24 bg-theme-1 text-white">-->
    <!--            Send-->
    <!--          </button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; END: Form Layout &ndash;&gt;-->
    <!--    </div>-->
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      settings: [
        {
          email: undefined,
          phone: undefined,
          telegram: undefined,
        }
      ],
      categories: "1",
      simpleEditorConfig: {},
      editorData: ""
    };
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    getSettings() {
      axios
          .get("pmst/settings/")
          .then(response => {
            let data = response.data;
            this.settings = data;
          })
          .catch(function(error) {
            console.error(error.response);
          });
    },
  }
};
</script>
